const ApiUrl = process.env.REACT_APP_API_URL;
const UserInfoEndpoint = "user-info";

const responseJsonParser = (text) => {
  try {
    return JSON.parse(text);
  } catch (_) {
    throw new Error(`Failed to parse response as JSON: ${text}`);
  }
};

const responseErrorHandler = (jsonBody) => {
  if (jsonBody?.["error"]) {
    throw jsonBody["error"];
  }
  return jsonBody;
};

class FiCurveApi {
  authToken;

  constructor(authToken) {
    this.authToken = authToken;
  }

  runGetUserInfo(responseHandler, errHandler) {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.authToken}`,
      },
    };

    fetch(this.buildUrl(UserInfoEndpoint), requestOptions)
      .then((res) => res.text())
      .then(responseJsonParser)
      .then(responseErrorHandler)
      .then(responseHandler, errHandler)
      .catch(errHandler);
  }

  buildUrl(endpoint) {
    return `${ApiUrl}/${endpoint}`;
  }
}

export default FiCurveApi;
